const takers = {
  firestorePath: 'takers',
  firestoreRefType: 'collection',
  moduleName: 'takers',
  statePropName: 'data',
  namespaced: true,
  fetch: {
    docLimit: 0, // 0 = no limit (library default is 50)
  },
  state: {},
  getters: {
    array: (state) => {
      const arr = Object.values(state.data);
      return arr.sort((a, b) => {
        const an = (a.name || '').toLowerCase();
        const bn = (b.name || '').toLowerCase();
        if (an < bn) return -1;
        if (an > bn) return 1;
        return 0;
      });
    },
    byId: (state) => (id) => state.data[id]
  },
  mutations: {},
  actions: {}
};

export default takers;
